import { Helmet } from 'react-helmet-async';
import AnalyticsBody from './body';

const AnalyticsPage = () => (
  <>
    <Helmet>
      <title>Analytics</title>
    </Helmet>
    <AnalyticsBody />
  </>
);

export default AnalyticsPage;
